import React from 'react'
import Navbar from '../Components/Navbar'
import WrapLocJoblist from '../Components/WrapLocJoblist';
import Footer from '../Components/Footer';



const Jobs = () => {
  return (
    <div>
      <Navbar />
      <WrapLocJoblist />
      <Footer />
    </div>
 )
}

export default Jobs;